/*
 * @Descripttion: 
 * @version: 
 * @Author: wzhe
 * @Date: 2019-11-21 14:58:04
 * @LastEditors: hanzb
 * @LastEditTime: 2020-04-15 16:05:26
 */
let SgiRowEO = function () {
    return ({
        justify: 'start',
        type: 'flex',
        ctlN: "行",
        align: 'top',
        // ctlH: "100%", //在form里拖行的时候高度100%比较恶心
        ctlW: "100%",
        // cldSet: [col1, col2],
        desId: "EP_EO_UI_5101"
    })
};

export { SgiRowEO };
export default SgiRowEO;


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCompEO/SgiRowEO.js